import { ReactNode } from 'react';

export function EmptyFormatter({ blankValue }: { blankValue: string }): ReactNode {
  return <span className='muted'>{blankValue}</span>;
}
